import { SxProps, Theme } from '@mui/material/styles';

export const textSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: 600,
  fontSize: '18px',
});

export const rowGridSx = {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
  flexDirection: 'row',
};

export const columnGridSx = {
  gap: '16px',
  display: 'flex',
  flexDirection: 'column',
};

export const boxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
};
